import { carrierTypeOptionById, carrierTypesOptions } from "../../../lib/systemData"
import classesCell from './BodyCell.module.css'

export default function MultipleOptionsCell({data, itemKey}) {

    let text = '';

    if (itemKey === 'major_med_coverage_type') {
        let options = carrierTypesOptions();
        let provText = '';
        if (options && data) {
            data.forEach((element, i) => {
                let foundItem = options.find((object) => object.value == element)
                if (!foundItem) {
                    foundItem = carrierTypeOptionById(element)
                }

                if (foundItem) {
                    const inactiveSuffix = foundItem.isDisabled ? ' (Inactive)' : ''
                    provText = provText + foundItem.label + inactiveSuffix + (i < data.length - 1 ? ', ' : '')
                }
            });
            text = provText;
        }
    }


    // old code
    // const [text, setText] = useState(null)
    
    // useEffect(() => {
    //     if (itemKey == 'major_med_coverage_type') {
    //         let options = carrierTypesOptions()
    //         let provText = ''
    //         if (options && data) {

    //             data.forEach((element, i) => {
    //                 const index = options.findIndex(object => {
    //                     return object.value == element
    //                 })

    //                 if (index !== -1) {
    //                     provText = provText + options[index].label + (i < data.length-1 ? ', ' : '')
    //                 }
    //             });

    //             setText(provText)
    
    //         }
    //     }
    // }, [data, itemKey])


    return <div className={`${classesCell.body_cell}`}>
        {text}
    </div>
}